import { render, staticRenderFns } from "./SwitchEditor.vue?vue&type=template&id=349722fa&scoped=true"
import script from "./SwitchEditor.vue?vue&type=script&lang=js"
export * from "./SwitchEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349722fa",
  null
  
)

export default component.exports